import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { appState } from '@/appState'
import { rootRoute } from '@/tenant/root'

export const apisRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/apis',
    component: lazyRouteComponent(() => import('./APIs'), 'APIs'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        return client.tenants.getTenantResources.query(
            {
                tenantId: appState.tenant!._id.toString(),
            },
            { signal: abortController.signal }
        )
    },
})
